import { FieldBase } from './field-base';

export class FieldCheckbox extends FieldBase<boolean> {
  override controlType = 'checkbox';
}
